import masterApi from 'src/apis/master'

export default {
  methods: {
    loadUserAndMasters() {
      const userPromise = this.loadUser_()
      this.loadMasters_(userPromise)
    },
    loadUser_() {
      return this.$store.dispatch('user/getMe')
    },
    loadMasters_() {
      const prms = masterApi.getAll()
        .then(({ data }) => {
          const lovs = {}
          Object.keys(data.lovs).forEach(listType => {
            lovs[listType] = {}
            lovs[listType].vals = data.lovs[listType]
            lovs[listType].map = lovs[listType].vals.reduce((acc, e) => {
              acc[e.key] = e; return acc
            }, {})
          })

          const masterData = data
          masterData.lovs = lovs
          const prms = window.master.$promise
          window.master = masterData
          window.master.$promise = prms
          // wait for user info
        })
        .then(() => {
          return window.master
        })
      window.master = { $promise: prms }
    },
    async waitForMasters(arg) {
      await window.master.$promise
      return arg
    },
    async ensureUserAndMasters() {
      const promises = [
        this.$store.dispatch('user/getMe'),
        window.master.$promise,
      ]
      const [user, masters] = await Promise.all(promises)
      return { user, masters }
    },
  },
}
